export class OnboardEmpFamilyDetail{
  ID: number;
  EmpID: number;
  Name: string;
  DOB: Date;
  RelationId: number;
  Age: number;
  Deceased: boolean;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}
